module.exports = __webpack_public_path__ + "static/media/lapinnimen-helmi.7c3c0aa5.png";